import {HandleSignup} from "../components/signup/HandleSignup";

export function HandleSignupPage() {
  return <HandleSignup />;
}
